import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import useHeadingBarStyles from './useHeadingBarStyles';
const HeadingBar = ({ bgcolor, title, noOfTasks, action, hasAction, type }) => {
    const styles = useHeadingBarStyles(type, hasAction);
    return (_jsxs(Box, { sx: { ...styles.mainBarContainer }, children: [_jsx(Box, { sx: { ...styles.indicator }, children: _jsx(Box, { sx: { width: 8, height: 8, bgcolor: 'white', borderRadius: '50%' } }) }), _jsx(Typography, { variant: 'body1', sx: { ...styles.titles }, children: title }), action] }));
};
export default HeadingBar;
